import BranchSummaryDto from "@/models/Branches/BranchSummaryDto";
import AgencyUserSummaryDto from "@/models/AgencyUsers/AgencyUserSummaryDto";
import WorkerSummaryDto from "@/models/Workers/WorkerSummaryDto";
import JobLocationSummaryDto from "@/models/Locations/JobLocationSummaryDto";
import JobRequirementsSummaryDto from "@/models/Jobs/JobRequirementsSummaryDto";
import AgencyIdentifierDto from "@/models/Agencies/AgencyIdentifierDto";


export default class AnonJobWorkerInviteDto {
    jobWorkerId = '';
    updatedAt: Date;
    url = '';
    agencyIdentifier: AgencyIdentifierDto = new AgencyIdentifierDto();
    agencyBranch: BranchSummaryDto = new BranchSummaryDto();
    agencyOwner: AgencyUserSummaryDto = new AgencyUserSummaryDto();
    worker: WorkerSummaryDto = new WorkerSummaryDto();
    location: JobLocationSummaryDto = new JobLocationSummaryDto();
    requirements: JobRequirementsSummaryDto = new JobRequirementsSummaryDto();
}
